import { render, staticRenderFns } from "./DialogImportNoteCustomer.vue?vue&type=template&id=63341827&scoped=true"
import script from "./DialogImportNoteCustomer.vue?vue&type=script&lang=js"
export * from "./DialogImportNoteCustomer.vue?vue&type=script&lang=js"
import style0 from "./DialogImportNoteCustomer.vue?vue&type=style&index=0&id=63341827&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63341827",
  null
  
)

export default component.exports